const extractSavedUpdatesIdsFromResponses = (responses) =>
  Array.prototype.concat.apply(
    [],
    responses.map((response) =>
      Array.isArray(response.updates)
        ? response.updates.map((update) => update.id)
        : [response.update?.id].filter((id) => !!id)
    )
  );

export { extractSavedUpdatesIdsFromResponses };
